import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";

import { BaseContractController } from "../_baseDealController";
import { EntityService } from "../../services/entity-service";
import { EntityConfigService } from "../../services/entity-config-service"
import { ContractService } from "../../services/contract-service";
import { VariesByCatalogService } from "../../services/varies-by-catalog-service";
import { ContractSharedDataService } from "../../services/contract-shared-data-service";
import { LocalCacheService } from "../../services/local-cache-service";
import { NotifyService } from "../../services/notify-service";
import { EventService } from "../../services/event-service";
import { AdminService } from "../../services/admin-service";
import { AclService } from "../../services/acl-service";

export class DealRightsManagerController extends BaseContractController {
	static $inject = ["$scope", "$q", "$window", "$timeout", "$interval", "$location", "$anchorScroll",
		"entityService", "entityConfigService", "contractService", "variesByCatalogService",
		"contractSharedDataService", "localCacheService", "notifyService", 
		"eventService", "adminService", "aclService"];

	contractID: string;
	initialized: boolean;
	locked: boolean;

	contract: Models.IEntityCharDataPair;
	rightTemplates: Models.ICharacteristicTemplate[];
	assets: Models.IRecordRelationshipPair[];
	associableAssets: Models.IRecordRelationshipPair[];
	//rights: Models.IContractRightDocumentRelationshipPair[];

	assetDictionary: { [key: number]: Models.IEntity };

	rightSetModalOpen: boolean;
	newRightCharDataCollection: Models.ICharDataCollection;
	selectedEntities: Models.IEntitySearchDoc[];

	toggleAll: boolean;

	filterModel: Models.IRightsFilterModel;
	searchNumFound: number;
	searchPage: number;
	searchPageCount: number;
	searchPageSize: number;

	canEdit: boolean;
	selectAllAssets: boolean;
	forceRefresh: boolean;

	selectedEntity: Models.IEntity | Models.IEntityRelationshipPair | Models.IContractRightDocumentRelationshipPair;
	showFilter: boolean;

	variesByCatalogOpenModal: boolean;
	hasVariesByCatalog: boolean;
	variesByCatalogParentTemplateID: string;
	variesByCatalogCharDataCollection: Models.ICharDataCollection;
	variesByCatalogSelectedAssets: { [key: number]: string };
	newRightsIDs: string[];
	canCopy: boolean;

	rightsDataDefaults: Models.IDataDefaultSet[];
	newDataDefaultSetEntityIDs: string[];

	relationshipCharTypeIDs: number[];
	relationshipRequired: { [key: number]: boolean };
	selectedContacts: string[];
	templateColors: { [key: number]: string } = {};

	constructor(
		$scope: ng.IScope,
		$q: ng.IQService,
		private $window: ng.IWindowService,
		private $timeout: ng.ITimeoutService,
		public $location: ng.ILocationService,
		public $anchorScroll: ng.IAnchorScrollService,
		$interval: ng.IIntervalService,
		entityService: EntityService,
		private entityConfigService: EntityConfigService,
		private contractService: ContractService,
		private variesByCatalogService: VariesByCatalogService,
		sharedData: ContractSharedDataService,
		localStorage: LocalCacheService,
		notifyService: NotifyService,
		private eventService: EventService,
		adminService: AdminService,
		private aclService: AclService) {

		super($scope, entityService, sharedData, localStorage, notifyService, adminService, $interval, $q, $location, $anchorScroll);

		this.contractID = "";
		this.initialized = false;
		this.locked = false;
		this.showFilter = true;

		this.contract = null;
		this.rightTemplates = [];
		//this.rights = [];
		this.assets = [];
		this.associableAssets = [];
		this.assetDictionary = {};

		this.rightSetModalOpen = false;
		this.newRightCharDataCollection = null;
		this.selectedEntities = [];

		this.toggleAll = false;

		this.canEdit = false;
		this.selectAllAssets = false;

		this.variesByCatalogOpenModal = false;
		this.hasVariesByCatalog = false;
		this.variesByCatalogSelectedAssets = {};
		this.canCopy = false;

		/* make asset records dictionary key accessible */
		$scope.$watchCollection(() => this.assets,
			(newValue, oldValue) => {
				this.assetDictionary = {};
				newValue.forEach((assetRelPair) => {
					this.assetDictionary[assetRelPair.record.recordID] = assetRelPair.record;
				});
			});

		$scope.$watch(() => this.variesByCatalogOpenModal,
			(newValue, oldValue) => {
				if (!newValue && oldValue) {
					if (!this.rightSetModalOpen) {
						this.selectedEntities = [];
						this.selectAllAssets = false;
						this.newRightCharDataCollection = null;
					}
				}
			});

		$scope.$watch(() => this.progressStatus, (newValue, oldValue) => {
			if (newValue != oldValue && newValue == "Done") {
				this.forceRefresh = true;
			}
		});

		$scope.$watch(() => this.variesByCatalogService.selectedFields, (newValue, oldValue) => {
			this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
		}, true);

		$scope.$watch(() => this.variesByCatalogService.selectedDimension, (newValue, oldValue) => {
			this.hasVariesByCatalog = this.variesByCatalogService.checkForVariesByCatalog();
		}, true);

		$scope.$watch(() => this.selectedEntities, (newValue, oldValue) => {
			if (newValue != oldValue) {
				this.setVariesByCatalogSelectedAssets();
			}
		}, true);

		this.$scope.$watch(() => {
			if (this.contractID == null) {
				return null;
			} else {
				return this.contractID;
			}
		},
			(newValue, oldValue) => {
				if (newValue != null) {
					this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
						return this.RefreshContract();
					});
				}
			});
	}

	private setVariesByCatalogSelectedAssets() {
		this.variesByCatalogSelectedAssets = {};
		this.selectedEntities.filter(c => c.charTypeID == Consts.CharTypeIDs.property).forEach(assetID => {

			if (this.assetDictionary[assetID.recordID] == null) {
				//Then this is an implicit relationship that we do not have info for, go get it
				this.entityService.getEntityRecord(assetID.entityID)
					.then((result) => {
						this.variesByCatalogSelectedAssets[assetID.recordID] = result.title;
					});
			}
			else {
				this.variesByCatalogSelectedAssets[assetID.recordID] = this.assetDictionary[assetID.recordID].title;
			}
		});
	}

	Init(entityID: string, canEdit: string) {
		this.contractID = entityID;
		this.canEdit = canEdit == "true";

		this.relationshipCharTypeIDs = [Consts.CharTypeIDs.property, Consts.CharTypeIDs.user];

		this.aclService.loadActivityAcls()
			.then((acls) => {
				this.canCopy = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod4);
			});

		var promise2 = this.RefreshContract();
		var promise3 = this.RefreshAssets();

		this.notifyService.startProgress();
		return this.$q.all([promise2, promise3])
			.then(() => {
				return this.RefreshValidation()
					.then(() => {
						this.initialized = true;
					});
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshContract(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.entityService.getEntity(this.contractID)
			.then((result) => {

				this.entityService.getAssociatedTemplatesDefaults(result.record.charTypeID, result.record.templateID, Consts.CharTypeIDs.right)
					.then((res) => {
						this.rightsDataDefaults = res.dataDefaultSets;
					});

				this.contract = result;
				if (this.contract.charDataCollection.status.lockIndicator > 0) {
					this.locked = true;
				} else {
					this.locked = false;
				}
				return this.RefreshTemplates();
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshTemplates(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.transaction, this.contract.record.templateID, Consts.CharTypeIDs.right)
			.then((result) => {
				this.rightTemplates = _.filter(result, r => Utils.AclUtil.hasCreateAccess(this.aclService.acls, r.acl));
				this.templateColors = result.reduce(function (map, obj) {
					map[obj.templateID] = obj.visualization;
					return map;
				}, {});
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshAssets(): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.entityService.getRelatedRecords(this.contractID, Consts.CharTypeIDs.property)
			.then((result) => {
				this.assets = result.filter((asset) => asset.relationship.relIndicatorID == 0);
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	RefreshValidation(): ng.IPromise<any> {
		return this.eventService.call(Consts.Events.ValidateEntity);
	}

	Delete() {
		if (this.$window.confirm("Are you sure you want to delete this Deal?") && this.$window.confirm("Are you REALLY SURE you want to delete this Deal?")) {
			this.notifyService.startProgress();
			this.contractService.deleteContract(this.contractID)
				.then(() => {
					this.$window.location.assign(Consts.Urls.ContractListPage);
				},
					() => {
						this.notifyService.notifyError("Error Deleting Deal");
					})
				.finally(() => {
					this.notifyService.endProgress();
				});
		} else {
			this.$scope.$broadcast(Consts.Events.NotifyDone);
		}
	}

	/*
	 * Opens the modal for creating a new RightSet
	 * @param template the template of the new rightset
	 * @param $event the click event of the <a> tag
	 */
	NewRight(template: Models.ICharacteristicTemplate, $event: ng.IAngularEvent) {
		$event.preventDefault();

		var divID = Utils.IdBuilder.splitEntityID(this.contractID).divID;
		var templateID = Utils.IdBuilder.buildTemplateID(divID, Consts.CharTypeIDs.right, template.templateID);

		this.relationshipRequired = {};
		_.forEach(this.relationshipCharTypeIDs, (relCharTypeID) => {
			this.entityConfigService.getRecordAssociationCharacteristicTemplateRequired(Consts.CharTypeIDs.right, template.templateID, relCharTypeID)
				.then((res) => {
					if (res && res.charTypeID) {
						this.relationshipRequired[relCharTypeID.toString()] = true;
					}
				});
		});

		this.notifyService.startProgress();
		this.entityService.getEmptyEntityCharData(templateID)
			.then((result) => {
				this.newRightCharDataCollection = result;
				this.variesByCatalogService.clearSavedFields();

				this.rightSetModalOpen = true;
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	/*
	 * Creates the new RightSet from the modal VCG
	 * @param charDataCollection chardata from the modal VCG
	 * @isValid the validity of the form containing the VCG
	 */
	CreateRight(charDataCollection: Models.ICharDataCollection, isValid: boolean) {
		if (isValid) {
			this.notifyService.startProgress();
			var templateID = Utils.IdBuilder.buildTemplateID(charDataCollection.templateMetaData.divID, charDataCollection.templateMetaData.charTypeID, charDataCollection.templateMetaData.templateID);
			var childEntityIDs: string[] = this.selectedEntities.map(s => s.entityID);

			if (childEntityIDs.length > 20) {
				this.notifyService.notifyInfo("You've selected more than 20 associated entities. This may take a few minutes to create.");
			}

			this.entityService.createEntityWithOptions(templateID, this.contractID, charDataCollection.charDatas, this.relationshipCharTypeIDs, childEntityIDs)
				.then((result) => {
					if (result.success) {
						this.notifyService.notifySuccess("Rights Created");
					} else {
						this.notifyService.notifyError("Error creating Rights");
					}
					this.forceRefresh = true;
				})
				.then(() => {
					this.newRightCharDataCollection = null;
					this.rightSetModalOpen = false;
					this.RefreshValidation();
				})
				.finally(() => {
					this.notifyService.endProgress();
				});
		}
	}

	/*
	 * Used with the Varies by Catalog option.  Creates multiple RightSets (one per Catalog item)
	 * using a modal to allow for "bulk" entry
	 */
	QuickRightsEntry(charDataCollection: Models.ICharDataCollection, isValid: boolean) {
		if (isValid) {
			this.notifyService.startProgress();
			if (this.selectedEntities.length > 20) {
				this.$window.confirm("Please be patient while we calculate your Rights. It may take us a minute to save you an hour.");
			}
			this.variesByCatalogOpenModal = true;
			this.variesByCatalogParentTemplateID = Utils.IdBuilder.buildTemplateID(charDataCollection.templateMetaData.divID, charDataCollection.templateMetaData.charTypeID, charDataCollection.templateMetaData.templateID);
			this.variesByCatalogCharDataCollection = _.cloneDeep(charDataCollection);
			this.selectedContacts = [];
			this.selectedContacts = this.selectedEntities.filter(c => c.charTypeID == Consts.CharTypeIDs.user)
				.map(entity => entity.entityID);
			this.rightSetModalOpen = false;
			this.notifyService.endProgress();
		}
	}

	CancelModal() {
		this.rightSetModalOpen = false;
		this.variesByCatalogService.clearSavedFields();
	}

	ToggleAll() {
		this.toggleAll = !this.toggleAll;
	}

	CopySuccessful(newEntityID: string) {
		//copy succeeded, navigate user to new entity
		this.$window.location.assign("/Go/" + newEntityID);
	}

	CopyDataDefaultSet(dataDefault: Models.IDataDefaultSet, entityID: any) {
		if (dataDefault.hasConfigurationError) {
			alert("This Rights Profile has Records with Templates that aren't configured for this Deal Template.");
			return;
		}

		var id: number = -1;
		var charTypeID: number = -1;
		if (parseInt(entityID)) {
			id = entityID;
		} else {
			id = Utils.IdBuilder.splitEntityID(entityID).recID;
			charTypeID = Utils.IdBuilder.splitEntityID(entityID).charTypeID;
		}
		this.notifyService.startProgress();

		this.entityService.copyDataDefaultSet(dataDefault.id, charTypeID, id, true)
			.then((result) => {
				this.newDataDefaultSetEntityIDs = [];
				if (result.success) {
					_.forEach(result.data, (r: string) => {
						this.newDataDefaultSetEntityIDs.push(r);
					});
				}

				this.$timeout(() => {
					this.forceRefresh = true;
				}, 500);
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}

	DeleteDataDefaultSet(setID: string) {
		this.notifyService.startProgress();

		this.entityService.deleteDataDefaultSet(setID)
			.then((res) => {
				var index = -1;
				for (var i = 0; i < this.rightsDataDefaults.length; i++) {
					if (this.rightsDataDefaults[i].id == setID) {
						index = i;
						break;
					}
				}

				if (index > -1) {
					this.rightsDataDefaults.splice(index, 1);
				}
			})
			.finally(() => {
				this.notifyService.endProgress();
			});
	}
}
